import { ExtendedFormTemplate } from "@/dentlab/src/pages/form-builder/types/formTypes";

export const SYSTEM_STANDARD_FORM_ID = "system-standard-form";

export const SYSTEM_STANDARD_FORM: ExtendedFormTemplate = {
	id: SYSTEM_STANDARD_FORM_ID,
	title: "Standardformular",
	description: null,
	organization_id: "system",
	created_at: "",
	modified_at: "",
	published_at: "2024-01-01T00:00:00.000Z",
	bg_color: null,
	slug: null,
	rules: [],
	definition: {
		sections: [
			{
				id: "sys-section-details",
				title: "Auftragsdetails",
				fields: [
					{
						id: "sys-field-patient-code",
						type: "text",
						label: "Patienten-Code",
						required: false,
					},
					{
						id: "sys-field-first-name",
						type: "text",
						label: "Vorname",
						required: false,
					},
					{
						id: "sys-field-last-name",
						type: "text",
						label: "Nachname",
						required: false,
					},
					{
						id: "sys-field-title",
						type: "text",
						label: "Auftragstitel",
						required: true,
					},
					{
						id: "sys-field-description",
						type: "textarea",
						label: "Beschreibung",
						required: true,
					},
					{
						id: "sys-field-odontogram",
						type: "odontogram",
						label: "Odontogramm",
						required: false,
						odontogramFields: [
							{
								id: "sys-field-tooth-info",
								type: "text",
								label: "Zahninformationen",
								required: false,
							},
						],
					},
					{
						id: "sys-field-files",
						type: "file",
						label: "Dateien",
						required: false,
					},
				],
			},
		],
	},
};
